<template>
  <div class="order-stats-container">
    <div class="flex items-center justify-between">
      <div class="flex gap-2 items-center">
        <img src="../../assets/order-icon.svg" class="w-4" />
        <h4>Orders</h4>
      </div>
      <button
        v-if="isTeamOwner"
        @click="handleViewOrders"
        class="whitebutton-gemnote button-gemnote-glass--tiny gray"
      >
        <span>View Orders</span>
      </button>
    </div>
    <div class="order-stat-items">
      <div class="order-stat-item">
        <h6>Orders this month</h6>
        <p :class="{ 'text-overflow': remainingShipments > 999999 }">
          {{ formatAverageShipments | formatNumber }}
        </p>
      </div>
      <div class="order-stat-item">
        <h6>Remaining orders this month</h6>
        <p :class="{ 'text-overflow': remainingShipments > 999999 }">
          {{ remainingShipments | formatNumber }}
        </p>
      </div>
      <div class="order-stat-item">
        <h6>Average volume per month</h6>
        <p :class="{ 'text-overflow': remainingShipments > 999999 }">
          {{ averageShipment | formatNumber }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../helpers'
export default {
  name: 'OrderStats',
  created() {
    this.$store.dispatch('report/avarageShipments')
  },
  computed: {
    loadGloabalDashboard() {
      return progressStatus(this.loadBarChart)
    },
    isTeamOwner() {
      return this.$store.getters['profile/isTeamOwner']
    },
    formatAverageShipments() {
      return this.averageShipments.toLocaleString('en-US')
    },
    ...mapState({
      loadBarChart: state => state.report.loadBarChart,
      averageShipments: state => state.report.averageShipments,
      remainingShipments: state => state.report.remainingShipments,
      averageShipment: state => state.report.averageShipment
    })
  },
  methods: {
    handleViewOrders() {
      this.$router.push({ name: 'orders' })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote--small {
  font-size: 0.813rem;
  font-weight: normal;
  height: 2.5rem;
  width: max-content !important;
  padding: 0 0rem !important;
}

.button-gemnote-glass--tiny {
  width: max-content !important;
  font-weight: 400 !important;
  padding: 0 1rem !important;
}

.order-stats-container {
  padding: 1rem;
  border: 1px solid $main-6;
  border-radius: 2px;

  .order-stat-items {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;

    .order-stat-item {
      text-align: left;
      h6 {
        font-size: 0.813rem;
      }
      p {
        font-size: 1.75rem;
        margin-top: 0.2rem;
      }
    }
  }
}

h4 {
  font-family: $editorial;
  font-weight: normal;
}

@media (max-width: 768px) {
  .order-stats-container {
    .order-stat-items {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
@media (max-width: 490px) {
  .order-stats-container {
    .order-stat-items {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
